"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    GOOGLE: 'GOOGLE',
    APPLE: 'APPLE',
    FACEBOOK: 'FACEBOOK',
    EMAIL: 'EMAIL',
    MOBILE: 'MOBILE',
};
